import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 2
const slug = 'site-cuts-and-benching-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Site Cuts & Benching Sydney | ${BUSINESS_NAME}`,
        description: "Full site preparation with precise site cuts and benching, creating level and stable platforms for construction.",
        keywords: "site cuts sydney, site benching, land leveling, site preparation, excavation services, earthmoving, soil removal, retaining walls, drainage solutions, foundation preparation, residential site cuts, commercial site cuts, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Site Cuts & Benching',
    description: 'Full site preparation with precise site cuts and benching, creating level and stable platforms for construction.',
    points: [
    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
